<template>
    <div class="row gapped">
        <span class="text-title">
            {{toLocal('certificates.periodity_text_label')}}
        </span>
        <div class="time-select">
            <input
                @input="onNumberInput($event, element, 'certificateBefore', 'certificate_reassign_before')"
                @keydown="onNumberKeydown"
                @paste="onNumberPaste($event, element, 'certificateBefore', 'certificate_reassign_before')"
                @compositionend="onNumberCompositionEnd($event, element, 'certificateBefore', 'certificate_reassign_before')"
                @change="saveRequest(element)"
                :maxlength="4"
                placeholder="0"
                :value="certificateBefore"
                type="text"
                inputmode="numeric"
                pattern="[0-9]*"
                :class="{ grayed: certificate_reassign_before == 0 }"
            />

            <CustomDropdown
                class="white-c-dropdown"
                :class="{ grayed: certificate_reassign_before == 0 }"
                :list="elementRepeatingDD"
                :compareChosen="certificateTypeObj"
                :options="{
                    closeOnClick: true,
                    checkbox: false,
                    customDDWidth: '150%',
                    customMaxHeight: '300px',
                    initial: certificateTypeObj ? certificateTypeObj.short : '',
                    containerClass: 'groups-table-dropdown',
                    searchBar: false,
                    attached: {
                        type: 'certificate',
                        element: element,
                    }
                }"
                @elClicked="changeElementType"
            />

            <span class="front-text">
                {{ toLocal("training_edit.test_questions_or") }}
            </span>
            <div
                class="time-select-btn"
                :class="{ active: certificate_reassign_before == 0 }"
                @click="clearElementTime('certificate', element)"
            >
                {{ toLocal("group.doesnt_repeat") }}
            </div>
        </div>
    </div>
</template>

<script>
import CustomDropdown from "@/components/layout/elements/CustomDropdown.vue";

export default {
    name: 'CertificateRepeatRow',
    props:{
        element:{
            type: Object
        },
        keyLabel:{
            type: String
        }
    },
    components:{
        CustomDropdown
    },
    data() {
        return {
            certificateBefore: 0,
            certificate_reassign_before: 0,
            certificateTypeObj: {
                id: 0,
                name: "generic.days_multiple",
                short: "generic.days_short",
            },
            elementRepeatingDD: [
                {
                    id: 0,
                    name: "generic.days_multiple",
                    short: "generic.days_short",
                },
                {
                    id: 1,
                    name: "generic.weeks_multiple",
                    short: "generic.weeks_short",
                },
                {
                    id: 2,
                    name: "generic.months_multiple",
                    short: "generic.months_short",
                },
                {
                    id: 3,
                    name: "generic.years_multiple",
                    short: "generic.years_short",
                },
            ],
        };
    },

    mounted() {
        if(this.element && this.element[this.keyLabel]){
            this.certificateBefore = this.element[this.keyLabel].certificate_reassign_before || 0;
            this.certificate_reassign_before = this.element[this.keyLabel].certificate_reassign_before || 0;
            const certTypeId = this.element[this.keyLabel].certificate_reassign_before_type || 0;
            this.certificateTypeObj = this.elementRepeatingDD.find(el => el.id == certTypeId) || this.elementRepeatingDD[0];
        }
    },

    methods: {
        onNumberKeydown(e){
            if(!e) return;
            const allowedKeys = [
                'Backspace',
                'Delete',
                'Tab',
                'Escape',
                'Enter',
                'ArrowLeft',
                'ArrowRight',
                'ArrowUp',
                'ArrowDown',
                'Home',
                'End'
            ];
            if(allowedKeys.includes(e.key)) return;
            if(e.ctrlKey || e.metaKey) return;
            if(/^[0-9]$/.test(e.key)) return;
            e.preventDefault();
        },
        onNumberPaste(e, element, key, key2){
            if(!e) return;
            e.preventDefault();
            const clipboard = e.clipboardData ? e.clipboardData.getData('text') : '';
            const digits = String(clipboard || '').replace(/[^0-9]/g, '');
            if(e.target){
                e.target.value = digits;
            }
            this.changeElementInfo({ target: { value: digits } }, element, element, key, key2);
        },
        onNumberCompositionEnd(e, element, key, key2){
            this.onNumberInput(e, element, key, key2);
        },
        onNumberInput(e, element, key, key2){
            if(!e || !e.target) return;
            const raw = e.target.value == null ? '' : String(e.target.value);
            const digits = raw.replace(/[^0-9]/g, '');
            if(digits !== raw){
                e.target.value = digits;
            }
            this.changeElementInfo(e, element, element, key, key2);
        },
        changeElementInfo(e, element, info, key, key2) {
            let value = 0;
            if(e){
                value = e.target.value;
                value = value.replace(/[^0-9]/g, '');
                if(isNaN(value) || value === ''){
                    value = 0;
                }
                value = parseInt(value);
            } else {
                if(key === 'certificateType'){
                    value = this.certificateTypeObj.id;
                }
                else{
                    value = this.certificateBefore;
                }
            }

            if(key === 'certificateBefore'){
                this.certificateBefore = value;
                this.certificate_reassign_before = value;
            }

            if(element && element[this.keyLabel]){
                this.$set(element[this.keyLabel], key2, value);
            }

            if(e == null){
                this.saveItem(element);
            }
        },
        saveRequest(element){
            this.saveItem(element)
        },
        saveItem(element){
            let settings = {
                periodic_mode: 1,
                training_repeats_every: 0,
                training_repeats_every_type: 0,
                certificate_reassign_before: this.certificate_reassign_before,
                certificate_reassign_before_type: this.certificateTypeObj.id,
            };
            this.$set(element, this.keyLabel, settings);
            this.$emit('saveItem', element)
        },
        clearElementTime(type, element) {
            if (type == "certificate") {
                if (element[this.keyLabel].certificate_reassign_before == 0) return;
                element[this.keyLabel].certificate_reassign_before = 0;
                element[this.keyLabel].certificate_reassign_before_type = 0;
                this.certificateBefore = 0;
                this.certificate_reassign_before = 0;
                this.certificateTypeObj = this.elementRepeatingDD[0];
            }
            this.saveItem(element);
        },
        changeElementType(id, attached) {
            if (attached.type == "certificate") {
                let type = this.elementRepeatingDD.find((el) => el.id == id);
                if(type){
                    this.certificateTypeObj = type;
                    this.changeElementInfo(
                        null,
                        this.element,
                        this.element,
                        'certificateType',
                        'certificate_reassign_before_type'
                    );
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.row {
    display: flex;
    gap: 4px;
    font-size: clamp(12px, 1.2vw, 14px);
    align-items: center;
    .result {
      font-weight: 600;
    }
    &.gapped {
      gap: 16px;
    }
}

.time-select {
  display: flex;
  gap: 8px;
  align-items: center;
  input {
    padding: 4px 2px;
    border-radius: 6px;
    border: 1px solid #b2b2b2;
    text-align: center;
    max-width: 48px;
    font-size: clamp(12px, 1.2vw, 14px);
  }
  .white-c-dropdown {
    border-radius: 6px;
    border: 1px solid #b2b2b2;
    background: #fff;
    color: hsla(0, 0%, 20%, 1);
    width: 90px;
    padding: 3px 10px;
    &:not(.no-padding-no-bg){
        background: white;
    }
    .dropdown-initial {
      font-size: clamp(12px, 1.2vw, 14px);
      .white path {
        stroke: hsla(0, 0%, 20%, 1);
      }
    }
  }
}

.time-select-btn {
  user-select: none;
  border-radius: 20px;
  background: #f4f4f4;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.12);
  font-size: clamp(12px, 1.2vw, 14px);
  color: #7d7d7d;
  padding: 4px 16px;
  cursor: pointer;
  transition: 0.25s;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    background: #4d4d4d;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.12);
    color: white;
  }
  &.active {
    background: #4d4d4d;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.12);
    color: white;
  }
}

.grayed {
  background-color: #f4f4f4;
  color: #7d7d7d;
}

.time-select {
  .grayed {
    background-color: #f4f4f4;
    color: #7d7d7d;
    &.white-c-dropdown[data-v-511d4d4c]:not(.no-padding-no-bg){
        background: #f4f4f4;
    }
  }
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  appearance: textfield;
  -moz-appearance: textfield;
}
</style>

<style lang="scss">
.white-c-dropdown{
  &.dropdown-container .dropdown-initial{
    .white{
      path{
        stroke: hsla(0, 0%, 20%, 1);
      }
    }
  }
}
.time-select {
  .grayed {
     &.dropdown-container .dropdown-initial{
      .white{
        path{
          stroke: rgba(51, 51, 51, 0.425);
        }
      }
    }
  }
}
</style>
